import { useEffect, useRef } from "react";

interface UseUnmountProps {
  onUnmount: () => void;
}

const useUnmount = ({ onUnmount }: UseUnmountProps) => {
  const onUnmountRef = useRef(onUnmount);

  useEffect(() => {
    onUnmountRef.current = onUnmount;
  }, [onUnmount]);

  useEffect(() => {
    return () => {
      onUnmountRef.current();
    };
  }, []);
};

export { useUnmount };
